import { computed, ref } from "vue";
import { useStore } from "vuex";
import { mensajeError } from "../../store/plataformaStore";

export function useRolesPlataforma() {
    const store = useStore();

    const spinner = ref(true);
    const isLoading = ref(false);
    const sinAcceso = ref(false);
    const alertTable = ref({ state: false, message: "", color: "success" });

    // Modales
    const modalForm = ref(false);
    const modalEliminar = ref(false);
    const modalAsignar = ref(false);
    const modalQuitar = ref(false);
    const rolSeleccionado = ref(null);
    const usuarioSeleccionado = ref(null);
    const form = ref({ nombre: "", descripcion: "" });
    const formError = ref(null);

    const showAlert = (message, color = "success", timeout = 5000) => {
        alertTable.value = { state: true, message, color };
        setTimeout(() => {
            alertTable.value.state = false;
        }, timeout);
    };

    const handleError = (error, porDefecto) => {
        if (error?.response?.status === 403) {
            sinAcceso.value = true;
            return;
        }
        showAlert(mensajeError(error, porDefecto), "danger");
        console.error("Roles de plataforma error:", error);
    };

    const getRoles = async () => {
        spinner.value = true;
        try {
            await store.dispatch("appPlataforma/getRolesAction");
        } catch (error) {
            handleError(error, "Error al cargar los roles de plataforma");
        } finally {
            spinner.value = false;
        }
    };

    // ---------- Crear / editar ----------
    const abrirForm = (rol = null) => {
        rolSeleccionado.value = rol;
        form.value = { nombre: rol?.nombre || "", descripcion: rol?.descripcion || "" };
        formError.value = null;
        modalForm.value = true;
    };

    const cerrarForm = () => {
        modalForm.value = false;
        rolSeleccionado.value = null;
    };

    const guardarRol = async () => {
        const nombre = form.value.nombre.trim();
        if (!nombre) {
            formError.value = "El nombre es obligatorio";
            return;
        }
        const data = { nombre, descripcion: form.value.descripcion?.trim() || null };

        isLoading.value = true;
        formError.value = null;
        try {
            if (rolSeleccionado.value) {
                await store.dispatch("appPlataforma/actualizarRolAction", { id: rolSeleccionado.value.id, data });
                showAlert("Rol actualizado", "success", 1500);
            } else {
                await store.dispatch("appPlataforma/crearRolAction", data);
                showAlert("Rol creado", "success", 1500);
            }
            cerrarForm();
            await getRoles();
        } catch (error) {
            if (error?.response?.status === 403) {
                cerrarForm();
                handleError(error);
            } else {
                formError.value = mensajeError(error, "No se pudo guardar el rol");
            }
        } finally {
            isLoading.value = false;
        }
    };

    // ---------- Eliminar ----------
    const abrirEliminar = (rol) => {
        rolSeleccionado.value = rol;
        modalEliminar.value = true;
    };

    const cerrarEliminar = () => {
        modalEliminar.value = false;
        rolSeleccionado.value = null;
    };

    const confirmarEliminar = async () => {
        if (!rolSeleccionado.value) return;
        isLoading.value = true;
        try {
            await store.dispatch("appPlataforma/eliminarRolAction", rolSeleccionado.value.id);
            showAlert("Rol eliminado", "success", 1500);
            await getRoles();
        } catch (error) {
            handleError(error, "No se pudo eliminar el rol");
        } finally {
            isLoading.value = false;
            cerrarEliminar();
        }
    };

    // ---------- Usuarios ----------
    const abrirAsignar = (rol) => {
        rolSeleccionado.value = rol;
        modalAsignar.value = true;
    };

    const abrirQuitar = (rol, usuario) => {
        rolSeleccionado.value = rol;
        usuarioSeleccionado.value = usuario;
        modalQuitar.value = true;
    };

    const cerrarModalesUsuario = async (mensaje) => {
        modalAsignar.value = false;
        modalQuitar.value = false;
        rolSeleccionado.value = null;
        usuarioSeleccionado.value = null;
        if (mensaje) {
            showAlert(mensaje, "success", 2500);
            await getRoles();
        }
    };

    const roles = computed(() => store.state.appPlataforma.roles);

    // Ids de usuarios que ya son admins, para marcarlos en la búsqueda
    const adminsActuales = computed(() => {
        const mapa = {};
        roles.value.forEach((rol) => {
            (rol.usuarios || []).forEach((u) => {
                mapa[u.id] = rol;
            });
        });
        return mapa;
    });

    return {
        roles,
        adminsActuales,
        spinner,
        isLoading,
        sinAcceso,
        alertTable,
        modalForm,
        modalEliminar,
        modalAsignar,
        modalQuitar,
        rolSeleccionado,
        usuarioSeleccionado,
        form,
        formError,
        getRoles,
        abrirForm,
        cerrarForm,
        guardarRol,
        abrirEliminar,
        cerrarEliminar,
        confirmarEliminar,
        abrirAsignar,
        abrirQuitar,
        cerrarModalesUsuario,
    };
}
